/* eslint-disable import/no-cycle */
import { call, put, takeLatest, delay } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import * as types from '../../user/actionTypes';

import { getPersistor } from '../../persistor';
import { startLoader, stopLoader } from '../../../utility/commonFunction';
import {
  inActiveUserSuccess,
  setRole,
  setUserExportList,
  setUserList,
  updateURLError,
  updateURLSuccess,
  updateUserSuccess,
  updateUserError,
  setUserDetails,
  getNextPageUserList,
  switchRoleSuccess,
} from '../../user/actions';
import {
  getNextPageUserApi,
  getRoleApi,
  getUserApi,
  getUserExportApi,
  getUserDetailApi,
  inActiveUserApi,
  selectPaymentStatus,
  switchRoleApi,
  updateURLsApi,
  updateUserApi,
} from '../requests/userRequest';
import { setItem } from '../../../utility/localStorageControl';
import {
  loginSuccess,
  setAlmaOnboardingDetails,
  setAlmaOnboardingStatus,
  setMe,
  setPaymentStatus,
  setUser,
  getMe,
} from '../../authentication/actions';

function* getUserListHandler(action) {
  if (action.payload.search) {
    yield delay(1000);
  }

  try {
    yield startLoader('transparent');
    const { data } = yield call(getUserApi, action.payload);

    yield put(setUserList(data));
    if (data?.status) {
      yield stopLoader('transparent');
    } else {
      yield toast.error(data?.errors?.message);
    }
  } finally {
    yield stopLoader('transparent');
  }
}
function* getUserExportListHandler(action) {
  if (action.payload.search) {
    yield delay(1000);
  }

  try {
    yield startLoader('transparent');
    const { data } = yield call(getUserExportApi, action.payload);

    yield put(setUserExportList(data));
    if (data?.status) {
      yield stopLoader('transparent');
    } else {
      yield toast.error(data?.errors?.message);
    }
  } finally {
    yield stopLoader('transparent');
  }
}

function* getNextPageUserListHandler(action) {
  if (action.payload.search) {
    yield delay(1000);
  }
  try {
    yield startLoader('transparent');
    const { data } = yield call(getNextPageUserApi, action.payload);
    if (data) {
      yield put(setUserList(data));
      yield stopLoader('transparent');
    }
  } finally {
    yield stopLoader('transparent');
  }
}

function* inactiveUserHandler(action) {
  yield startLoader('transparent');
  try {
    const { data } = yield call(inActiveUserApi, action.payload);
    if (data.status) {
      yield stopLoader('transparent');
      yield put(inActiveUserSuccess(true));
      yield toast.success(data?.message);
    } else {
      yield stopLoader('transparent');
    }
  } finally {
    yield stopLoader('transparent');
  }
}

function* getRoleHandler() {
  try {
    const { data } = yield call(getRoleApi);
    if (data) {
      yield put(setRole(data.roles));
    } else {
      yield put(setRole([]));
      yield toast.error('Data not found');
    }
  } finally {
    // yield stopLoader('transparent');
  }
}

function* updateURLsHandler(action) {
  try {
    const { data } = yield call(updateURLsApi, action.payload);
    if (data.status) {
      yield put(updateURLSuccess(data.status));
      yield toast.success(data?.message);
    } else {
      yield put(updateURLError(data.roles));
      yield toast.error(data?.errors);
    }
  } finally {
    // yield stopLoader('transparent');
  }
}

function* updateUserHandler(action) {
  const { id, listParams, ...rest } = action.payload || {};
  if (!id) return;
  const payload = {
    payment_url: rest.payment_url ?? rest.slug ?? null,
    thank_you_url: rest.thank_you_url ?? rest.thankyou_url ?? null,
    package_id: rest.package_id ?? null,
    source_id: rest.source_id ?? null,
    sales_agent_id: rest.sales_agent_id ?? null,
  };
  try {
    yield startLoader('transparent');
    const { data } = yield call(updateUserApi, id, payload);
    if (data?.status) {
      yield put(updateUserSuccess(true));
      yield toast.success(data?.message || 'User updated successfully.');
      if (listParams && typeof listParams === 'object') {
        yield put(
          getNextPageUserList({
            page: listParams.page || 1,
            search: listParams.search || '',
            alma_status: listParams.alma_status || [],
            stripe_status: listParams.stripe_status || [],
          }),
        );
      }
    } else {
      yield put(updateUserError(data?.errors || data));
      const msg = data?.errors?.message || data?.message || 'Failed to update user.';
      yield toast.error(msg);
    }
  } catch (error) {
    const errMsg = error?.response?.data?.message || error?.message || 'Failed to update user.';
    yield put(updateUserError(errMsg));
    yield toast.error(errMsg);
  } finally {
    yield stopLoader('transparent');
  }
}

function* getUserDetailsHandler(action) {
  const { id } = action.payload || {};
  if (!id) return;
  try {
    const { data } = yield call(getUserDetailApi, id);
    if (data?.status && data?.data) {
      yield put(setUserDetails(data.data));
    } else {
      yield toast.error(data?.errors?.message || 'Failed to load user details.');
    }
  } catch (error) {
    yield toast.error(error?.response?.data?.message || error?.message || 'Failed to load user details.');
  }
}

function* switchRolehandler(action) {
  try {
    const { data } = yield call(switchRoleApi, action.payload);
    if (data?.status) {
      yield setItem('access_token', data?.data?.access_token);
      yield toast.success(data?.message);
      yield put(loginSuccess(data.data.access_token));
      const modifydata = {
        business_name: data?.data?.user?.user_business_details?.business_name,
        logo: data?.data?.user?.user_business_details?.logo,
        colour: data?.data?.user?.user_business_details?.colour,
        status: data?.data?.user?.user_business_details?.status,
        email: data?.data?.user?.email,
        role: data?.data?.user?.role || data?.data?.user?.roles?.[0],
        slug: data?.data?.user?.user_business_details?.link?.[0]?.slug,
        business_category: data?.data?.user?.user_business_details?.business_category?.name,
        business_category_id: data?.data?.user?.user_business_details?.business_category?.id,
        status_label: data?.data?.user?.user_business_details?.status_label,
      };
      yield put(setUser(modifydata));
      yield put(setAlmaOnboardingStatus(data?.data?.user?.user_business_details?.alma_onboarding_status));
      const payload = {
        data: data?.data?.user?.user_business_details?.alma_onboarding_details,
        label_status: data?.data?.user?.user_business_details?.alma_onboarding_status_label,
      };

      yield put(setAlmaOnboardingDetails(payload));
      // Refresh full profile using the same flow as login (me API based on role)
      yield put(getMe());
      // Flush persist so updated auth state is saved
      const persistor = getPersistor();
      if (persistor && typeof persistor.flush === 'function') {
        yield persistor.flush();
      }
      yield put(switchRoleSuccess(!!data?.data?.is_switch));
    } else {
      yield put(updateURLError(data?.errors || data?.message || data));
      yield toast.error(data?.message || data?.errors?.message || 'Unable to switch account.');
    }
  } finally {
    // yield stopLoader('transparent');
  }
}

function* selectPaymentStatusHandler(value) {
  yield startLoader('transparent');
  try {
    const { data } = yield call(selectPaymentStatus, value?.data);

    if (data.status) {
      yield put(setPaymentStatus(data?.data));
      yield stopLoader('transparent');
    } else {
      yield toast.error(data?.errors?.message);
      yield stopLoader('transparent');
    }
  } catch (err) {
    console.log(err);
  }
}

// function* submitAlmaOnboardingDetails(value) {
//   yield startLoader('transparent');
//   try {
//     const { data } = yield call(almaOnboardingApi, value?.payload);

//     if (data.status) {
//       yield put(setPaymentStatus(data?.data));
//       yield stopLoader('transparent');
//     } else {
//       yield toast.error(data?.errors?.message);
//       yield stopLoader('transparent');
//     }
//   } catch (err) {
//     console.log(err);
//   }
// }
export default function* userSaga() {
  yield takeLatest(types.GET_USER_LIST, getUserListHandler);
  yield takeLatest(types.GET_USER_EXPORT_LIST, getUserExportListHandler);
  yield takeLatest(types.GET_NEXT_PAGE_USER_LIST, getNextPageUserListHandler);
  yield takeLatest(types.GET_ROLE, getRoleHandler);
  yield takeLatest(types.INACTIVE_USER, inactiveUserHandler);
  yield takeLatest(types.UPDATE_URLS, updateURLsHandler);
  yield takeLatest(types.UPDATE_USER, updateUserHandler);
  yield takeLatest(types.GET_USER_DETAILS, getUserDetailsHandler);
  yield takeLatest(types.SWITCH_ROLE, switchRolehandler);
  yield takeLatest(types.SELECT_LANGUAGE, selectPaymentStatusHandler);
}
